import React from 'react';
import { Box, Chip } from '@mui/material';
import { Tag } from '../../types';
import { useLang } from '../../contexts/langContext';

export type TagFilter = string[]; // empty array means "All"

interface TagFilterChipsProps {
  tags: Tag[];
  selectedTagIds: string[];
  onChange: (ids: string[]) => void;
  tagCounts?: Record<string | 'all', number>;
}

const TagFilterChips: React.FC<TagFilterChipsProps> = ({
  tags,
  selectedTagIds,
  onChange,
  tagCounts,
}) => {
  const { lang } = useLang();

  const isAllSelected = selectedTagIds.length === 0;

  const toggleTag = (id: string) => {
    if (selectedTagIds.includes(id)) {
      onChange(selectedTagIds.filter((t) => t !== id));
    } else {
      onChange([...selectedTagIds, id]);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        overflowX: 'auto',
        gap: 0,
        py: 1,
        scrollbarWidth: 'none', // Firefox
        '&::-webkit-scrollbar': {
          display: 'none', // Chrome, Safari, Edge
        },
        '&::-webkit-scrollbar-track': {
          display: 'none',
        },
        '&::-webkit-scrollbar-thumb': {
          display: 'none',
        },
      }}
    >
      <Chip
        label={
          tagCounts
            ? `${lang === 'en' ? 'All' : '全部'} (${tagCounts.all ?? 0})`
            : lang === 'en' ? 'All' : '全部'
        }
        variant={isAllSelected ? 'filled' : 'outlined'}
        color={isAllSelected ? 'secondary' : 'default'}
        onClick={() => onChange([])}
        sx={{ flexShrink: 0, mx: 0.5 }}
      />
      {tags.map((tag) => {
        const selected = selectedTagIds.includes(tag._id);
        return (
          <Chip
            key={tag._id}
            label={
              tagCounts ? `${tag.name} (${tagCounts[tag._id] ?? 0})` : tag.name
            }
            variant={selected ? 'filled' : 'outlined'}
            color={selected ? 'secondary' : 'default'}
            onClick={() => toggleTag(tag._id)}
            sx={{ flexShrink: 0, mx: 0.5 }}
          />
        );
      })}
    </Box>
  );
};

export default TagFilterChips; 